module.exports = __webpack_public_path__ + "fonts/iconfont.291c2f62.woff2";